export default "__VITE_ASSET__C7NK3Ojv__"